export class TaskViewDTO {
  taskViewId: number = 0;

  ownerId: string = '';

  name: string = '';

  filterValues: string[] = [];

  sourceRoute: string | null = null;

  isShared: boolean = false;

  parentViewId: number | null = null;

  createdAt: string = '';

  updatedAt: string = '';

  revision: string = '';

  ownedByMe: boolean = false;

  showInSidebar: boolean = false;
}

export class TaskViewCreateDTO {
  name: string = '';

  filterValues: string[] = [];

  sourceRoute: string | null = null;

  parentViewId: number | null = null;
}

export class TaskViewUpdateDTO {
  name: string = '';

  filterValues: string[] = [];

  sourceRoute: string | null = null;

  parentViewId: number | null = null;

  revision: string = '';
}

// POST taskviews/copy. With sourceTaskViewId the server copies that view and a
// null filterValues/sourceRoute takes the source's value; without it, name is
// the template label and filters and route come from the body. The server
// picks the first free "Name (n)" either way.
export class TaskViewCopyDTO {
  sourceTaskViewId: number | null = null;

  name: string | null = null;

  filterValues: string[] | null = null;

  sourceRoute: string | null = null;
}

export class TaskViewLayoutDTO {
  revision?: string;

  version: number = 1;

  viewOrder: string[] = [];

  hiddenTemplateViewKeys: string[] = [];

  hiddenCustomViewKeys: string[] = [];

  hiddenSidebarViewKeys: string[] = [];

  // Per-view member-filter selections, keyed by view key. Covers both template
  // and custom views; a view whose member filter is the default (current user
  // only) has no entry here.
  viewMemberFilters?: Record<string, string[]>;

  // Per-standard-view main task-filter overrides, keyed by view key. A standard
  // view whose filter still equals the default has no entry.
  standardViewFilterOverrides?: Record<string, string[]>;
}

export class TaskViewLayoutUpdateDTO {
  layout: TaskViewLayoutDTO = new TaskViewLayoutDTO();
}
